import {NEXT_STEP_REQUEST} from "../types";

export const nextStep = (element) => dispatch => {
    dispatch({
        type: NEXT_STEP_REQUEST,
        payload: element
    })
}



// WEBPACK FOOTER //
// ./src/actions/WizardActions/WizardAction.js